import { useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { useAsyncCall } from '~/hooks'
import { getReturnPortal } from '~/model'

export const useReturnPortal = () => {
  const { portalId } = useParams<{ portalId: string }>()
  const [returnPortal, { isLoading }] = useAsyncCall(useCallback(() => getReturnPortal(portalId ?? ''), [portalId]))

  return {
    returnPortal,
    isLoading,
  }
}
